import CaseFirstViewWhite from 'components/cases/common/CasesFirstViewWhite/'
import OverView from 'components/cases/common/Overview/'
import Interview from 'components/cases/coreka/Interview/Interview'
import CaseStudyNew from '../../home/CaseStudy/CaseStudyNew'
import { firstViewItemWhite, overviewItem, overviewTitle, issueSolutionItems, caseCTAItem } from './CorekaItems'
import CaseCTA from 'components/cases/common/CaseCTA'
import FooterCTA from 'components/common/FooterCTA'
import styles from 'components/cases/coreka/coreka.module.scss'

const Coreka = (): JSX.Element => {
  return (
    <>
      <CaseFirstViewWhite firstViewItemWhite={firstViewItemWhite} />
      <OverView overviewItem={overviewItem} issueSolutionItems={issueSolutionItems} overviewTitle={overviewTitle} />
      <Interview />
      <CaseCTA {...caseCTAItem} />
      <FooterCTA />
      <div className={styles.line}>
        <CaseStudyNew />
      </div>
  </>
  )
}

export default Coreka
